import { Route, Routes } from "react-router-dom";

import AppointmentList from "./list";
import Appointment from "./appointment";
import Details from "./details";

const ControlTowerAppointmentsRoutes = (props: any) => (
	<Routes>
		<Route path="/" element={<AppointmentList {...props} />} />
		<Route path="/:id" element={<Details {...props} />} />
		<Route path="/appointment" element={<Appointment {...props} />} />
	</Routes>
);

export default ControlTowerAppointmentsRoutes;
